import faker from 'faker';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import {
  Box,
  Card,
  Table,
  Button,
  Divider,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  CardHeader,
  TableContainer,
  Input,
  TextField,
  InputLabel, Select, MenuItem, Typography, Grid, Container
} from '@material-ui/core';
// utils
// import { fCurrency } from '../../../utils/formatNumber';
import { fCurrency } from '../../../../utils/formatNumber';
//
// import Label from '../../Label';
// import Scrollbar from '../../Scrollbar';
// import MoreMenuButton from '../../MoreMenuButton';
import Scrollbar from 'src/components/Scrollbar';
import Label from 'src/components/Label';
import { Link , useLocation } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../../../routes/paths';
import DualShok from '../../../../assets/img/dualShock.png'
import { useSnackbar } from 'notistack';

// ----------------------------------------------------------------------
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import ProductTimeline from './ProductTimeLine';
import { MIconButton } from '../../../@material-extend';
import closeFill from '@iconify/icons-eva/close-fill';
import StatusDescription from './StatusDescription';

// ----------------------------------------------------------------------

export default function HomeProductDetails() {
  const theme = useTheme();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
     

  const handleSave=()=> {
    enqueueSnackbar('Item Saved', {
      variant: 'success',
      action: (key) => (
        <MIconButton size="small" onClick={() => closeSnackbar(key)}>
          <Icon icon={closeFill} />
        </MIconButton>
      )
    });
  }
  const handleSubmit=()=> {
    enqueueSnackbar('Item submited Successfully', {
      variant: 'success',
      action: (key) => (
        <MIconButton size="small" onClick={() => closeSnackbar(key)}>
          <Icon icon={closeFill} />
        </MIconButton>
      )
    });
  }
  return (
    <Card sx={{p:3}}>
      {/* <CardHeader title="Item Details" sx={{ mb: 3 }} /> */}
     <Box sx={{width:"100%",display:"flex",justifyContent:"space-between"}}>
        <Typography>Item Details</Typography>
        <Button sx={{color:"red",border:"1px solid",borderColor:"#32b59f"}}>
        <Typography>Transaction Status:Awaiting Aproval</Typography>
        </Button>
        <Link underline="none" component={RouterLink} to={PATH_DASHBOARD.orderHistory.root}>
        <Typography align='right'>Back</Typography>
        </Link>
     </Box>
      {/* <Divider sx={{backgroundColor: '#32b59f',mt:2}} /> */}
      <Box sx={{ width: "100%"}}>
      <Grid container spacing={2}>
    
        <Grid item xs={12} sm={2} sx={{mt:3}}>
          <img src={DualShok} width={"100%"} alt='img' />
        </Grid>
       
        <Grid item xs={12} sm={10} container direction="column"  >
         
          <Grid item sx={{marginLeft:"10px",marginTop:"20px",display:"flex"}}> 
          <Box>
          <Typography fontSize={"small"}>Item Name</Typography>
          <Typography fontSize={"small"}>DualShock 4 wireless controller for payStation 4-Fortnite jet lack</Typography>
          </Box>
          <Box sx={{ml:8}}>
          <Typography fontSize={"small"}>Customer Name</Typography>
          <Typography fontSize={"small"}>Felix chizzoba</Typography>
          </Box>
          <Box sx={{ml:5}}>
          <Typography fontSize={"small"}>Phone</Typography>
          <Typography fontSize={"small"}>234 9965432</Typography>
          </Box>
          <Box sx={{ml:3}}>
          <Typography fontSize={"small"}>Email</Typography>
          <Typography fontSize={"small"}>customer1@gmail.com</Typography>
          </Box>
          </Grid>
           
         
          <Grid item  sx={{marginLeft:"10px",marginTop:"10px",display:"flex"}}> 
          <Box>
          <Typography fontSize={"small"}>Cost of item</Typography>
          <Typography fontSize={"small"}>$ 50</Typography>
          </Box>
          <Box sx={{ml:6}}>
          <Typography fontSize={"small"}>Order no</Typography>
          <Typography fontSize={"small"}>000012</Typography>
          </Box>
          <Box sx={{ml:6}}>
          <Typography fontSize={"small"}>Supplier Order no</Typography>
          <Typography fontSize={"small"} align='center'>----</Typography>
          </Box>

          <Box sx={{ml:8}}>
          <Typography fontSize={"small"}>Address</Typography>
          <Typography fontSize={"small"} >Mr Daniel Izuchukwu Nwoye. 8, My Street, Ilassan Lekki, Lagos 105102.</Typography>
          </Box>
           </Grid>
           
        </Grid>
      </Grid>
    </Box>
      <Scrollbar>
        <Box sx={{mt:5}}>
        <StatusDescription/>

        <Box sx={{display:"flex",alignItems:"center",justifyContent:"end",mt:2}}>
                 <Link underline="none" component={RouterLink} to={PATH_DASHBOARD.root}>
                 <Button variant='contained'sx={{mr:3,backgroundColor:"#32b59f"}} >Close</Button>
                 </Link>
                 
                 <Button variant='contained' sx={{backgroundColor:"#32b59f",mr:3}} onClick={handleSave}>Save</Button>
                 <Button variant='contained' sx={{backgroundColor:"#32b59f"}} onClick={handleSubmit}>Submit</Button>
                  
                 </Box>
        </Box>
      </Scrollbar>

              {/* <Box sx={{display:{xs:"flex",md:"none",justifyContent:"center",marginTop:"20px"}}}>
                 <ProductTimeline />              
              </Box>              */}

      {/* <Box sx={{ p: 2, textAlign: 'right' }}>
        <Button
          to="#"
          size="small"
          color="inherit"
          component={RouterLink}
          endIcon={<Icon icon={arrowIosForwardFill} />}
        >
          View All
        </Button>
      </Box> */}
    </Card>
  );
}
